import React, { useEffect, useState } from "react";
import "./TaskAssignment.css";
import { Box, Dialog, DialogContent, Grid, Pagination, Stack, styled, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography, } from "@mui/material";
import { Avatar, AvatarGroup } from '@mui/joy';
import { taskAssign } from "../../config/images";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from 'dayjs';
import { getTaskAssignmentDetails, getTaskSubmitReport, sendReminder } from "../../config/services";
import ImageGallery from "../../components/ImageGallery/ImageGallery";
import translations from "../../config/language";
import { notifyError, notifySuccess } from "../../config/ToastMessage";
import { useSelector } from "react-redux";

function clampAvatars(avatars, maxVisible = 3) {
  const totalAvatars = avatars.length;
  const visibleAvatars = avatars.slice(0, maxVisible); // Show only 3
  const surplus = totalAvatars > maxVisible ? totalAvatars - maxVisible : 0; // Extra count

  return { avatars: visibleAvatars, surplus };
}
const TaskDetail = ({ galleryIsOpen, setGalleryIsOpen }) => {

  const handleBackClick = () => {
    const currentPage = new URLSearchParams(window.location.search).get('page') || 1;
    navigate(`/task-assignment?page=${currentPage}`);
  };

  const navigate = useNavigate();
  const params = useParams();

  const [reminderModal, setReminderModal] = useState(false);
  const [taskDetails, setTaskDetails] = useState([]);

  const language = process.env.REACT_APP_LANGUAGE;

  const tasks = [
    {
      title: translations[language].taskTitle,
      desc: taskDetails?.title,
    },
    {
      title: "Data Collector",
      desc: taskDetails?.data_collector_name,
    },
    {
      title: "Description",
      desc: taskDetails?.description,
    },
    {
      title: "Region",
      desc: taskDetails?.region_name,
    },
    {
      title: "State",
      desc: taskDetails?.state_name,
    },
    {
      title: "Local Government ",
      desc: taskDetails?.local_government_name,
    },
    {
      title: "Number of farmers",
      desc: taskDetails?.number_of_farmers,
    },
    {
      title: "Deadline",
      desc: dayjs(taskDetails.deadline_of_task).format("DD/MM/YYYY"),
    },
    {
      title: "Status",
      desc: taskDetails?.status == 7 ? "Completed" : "Pending",
    },
  ];

  const [images, setImages] = useState([]);
  const [imageIndex, setImageIndex] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [tasksReport, setTasksReport] = useState([]);
  const [farmerCount, setFarmerCount] = useState("");
  const [totalFarmerCount, setTotalFarmerCount] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState();
  const [perPage, setPerPage] = useState(10);
  const [reminderData, setReminderData] = useState({
    taskTitle: "",
    taskDescription: ""
  });
  const { module_access } = useSelector((state) => state.userState)
  const isAccess = module_access?.find((module) =>
    module.module_name === "Task Assignment" && module.is_editor === true
  ) ? true : false;
  const handleChange = (e) => {
    const { name, value } = e.target;
    setReminderData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }

    if (!reminderData.taskTitle) {
      notifyError(translations[language].pleaseEnterTaskTitle);
      return true;
    }
    if (!reminderData.taskDescription) {
      notifyError(translations[language].pleaseEnterTaskDescription);
      return true;

    }
    const params = {
      assign_task_id: taskDetails.id,
      title: reminderData.taskTitle,
      description: reminderData.taskDescription
    }
    try {
      setIsLoading(true);
      const resp = await sendReminder(params);
      if (resp.data.success == true) {
        notifySuccess(resp.data.message);
        setReminderModal(false);
        setTimeout(() => {
          setIsLoading(false);
        }, 2000);
      }


    } catch (error) {
      console.log("error", error);
      notifyError(error.response.data.message);
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
      setReminderModal(false);
    }

  }

  const fetchData = async () => {

    try {
      const resp = await getTaskAssignmentDetails(params.id);
      if (resp.status == 200) {
        setTaskDetails(resp.data)
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    fetchData()
  }, []);

  const handleGalleryOpen = (items, index) => {
    setGalleryIsOpen(true);
    setImages(items);
    setImageIndex(index);
  }

  const fetchTaskReport = async () => {
    const data = {
      assign_task_id: params.id
    }
    try {
      const resp = await getTaskSubmitReport(data, currentPage, perPage);
      if (resp.data.results.success == true) {
        setTasksReport(resp.data.results.payload);
        setFarmerCount(resp.data.results.farmer_count);
        setTotalFarmerCount(resp.data.results.no_of_farmers);
        setCount(resp.data.count)
      }
    } catch (error) {
      console.log("error", error);
    }
  }

  useEffect(() => {
    fetchTaskReport()
  }, [currentPage]);

  const CustomPagination = styled(Pagination)(({ theme }) => ({
    "& .MuiPaginationItem-root": {
      borderColor: "none",
      borderWidth: "none",
      borderStyle: "none",
      marginTop: "30px",
    },
    "& .Mui-selected": {
      borderColor: "#31A05F",
      backgroundColor: "#31A05F !important",
      color: "#ffffff !important",
    },
  }));

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  return (
    <>
      <Box className="task-detail-box">
        <Box className="d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap" }}>
          <Box className="d-flex gap-3 img-box" style={{ padding: "25px" }}>
            <img
              src={taskAssign.backArrow}
              alt=""
              style={{ height: "44px", width: "44px", cursor: "pointer" }}
              onClick={() => handleBackClick()}
            />
            <img
              src={taskAssign.taskDetail}
              alt=""
            // style={{ height: "44px", width: "44px" }}
            />
            <Typography variant="h6" gutterBottom>
              {translations[language].taskDetailsView}
            </Typography>
          </Box>
          <Box className="d-flex align-items-center" style={{ flexWrap: "wrap" }}>
            <Typography variant="h6" gutterBottom>
              {translations[language].status}: <b>{farmerCount}/{totalFarmerCount}</b>
            </Typography>
            <button
              className="assign-task-btn"
              style={{ cursor: isLoading ? "not-allowed" : "pointer", height: "46px" }}
              onClick={() => {
                if (!isAccess) {
                  notifyError(translations[language].youDontHaveAccess);
                  return;
                }
                setReminderModal(true)
              }}
              disabled={isLoading}
            >
              {translations[language].sendReminder}
            </button>
          </Box>
        </Box>
        <Box className="pt-3">
          <Typography
            variant="body1"
            gutterBottom
            style={{ marginLeft: "20px", color: "#3C4856" }}
          >
            <b>{taskDetails?.data_collector_name}</b>
          </Typography>
          <Grid container className="task-detail-table">
            {tasks.map((task, index) => (
              <React.Fragment key={index}>
                <Grid item xs={12} sm={4} md={4} lg={4} className="grid-item"
                  style={{ borderTop: index === 0 ? "1px solid #D9D9D9" : "", paddingLeft: "25px" }}
                >
                  {task.title}
                </Grid>
                <Grid item xs={12} sm={8} md={8} lg={8} className="grid-item" style={{ borderTop: index === 0 ? "1px solid #D9D9D9" : "" }}>
                  {task.title === "Status" ? (
                    <b style={{ color: task.desc === "Completed" ? "#31A05F" : "inherit" }}>
                      {task.desc}
                    </b>
                  ) : (
                    <b>{task.desc}</b>
                  )}
                </Grid>
              </React.Fragment>
            ))}
          </Grid>

        </Box>
        {tasksReport.length > 0 &&
          <Box className="pt-5">
            <Typography
              variant="body1"
              gutterBottom
              style={{ marginLeft: "20px", color: "#3C4856" }}
            >
              <b>{translations[language].tasksReportSubmission}</b>
            </Typography>
            <Box style={{ minHeight: "max-content", maxHeight: "50vh", width: "100%", overflowX: "auto" }}>
              <Table className="task-assign-table task-sub-table" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>{translations[language].srNo}</TableCell>
                    <TableCell>{translations[language].date}</TableCell>
                    <TableCell>{translations[language].taskTitle}</TableCell>
                    <TableCell>{translations[language].farmersRegistered}</TableCell>
                    <TableCell>{translations[language].summary}</TableCell>
                    <TableCell>{translations[language].attachments}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tasksReport.map((task, index) => {
                    const { avatars, surplus } = clampAvatars(task.attachment.map(photo => photo.files), 3);

                    return (
                      <TableRow key={index}>
                        <TableCell style={{ textAlign: "center" }}>{index + 1 + (currentPage - 1) * perPage}</TableCell>
                        <TableCell>{dayjs(task.created_at).format("YYYY/MM/DD")}</TableCell>
                        <TableCell>{task.assigned_task_title}</TableCell>
                        <TableCell>{task.number_of_farmers}</TableCell>
                        <TableCell>{task.summary.slice(0, 100)}</TableCell>
                        <TableCell>
                          <AvatarGroup sx={{ "--AvatarGroup-gap": "-16px" }}>
                            {avatars.map((photo, i) => (
                              <Avatar
                                key={i}
                                className="cursor-pointer"
                                style={{ cursor: "pointer" }}
                                sx={{ width: 35, height: 35 }}
                                onClick={() => handleGalleryOpen(task.attachment.map(photo => photo.files), i)}
                              >
                                <img
                                  src={photo || "/placeholder.svg"}
                                  alt={`Attachment ${i + 1}`}
                                  style={{
                                    width: 35,
                                    height: 35,
                                    objectFit: "cover",
                                  }}
                                />
                              </Avatar>
                            ))}
                            {surplus > 0 && (
                              <Avatar
                                sx={{
                                  width: 35,
                                  height: 35,
                                  backgroundColor: "#3C4856",
                                  color: "#FFFFFF",
                                  fontSize: 14,
                                  fontWeight: 400,
                                  cursor: "pointer",
                                }}
                                onClick={() => handleGalleryOpen(task.attachment.map(photo => photo.files), 3)} // start from 4th index as preview
                              >
                                +{surplus}
                              </Avatar>
                            )}
                          </AvatarGroup>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
            <Box display="flex" justifyContent="end" alignItems="center" className="pagination">
              <Stack spacing={2} className="mb-3">
                <CustomPagination
                  count={Math.ceil(count / perPage)}
                  page={currentPage}
                  onChange={handlePageChange}
                  color="primary"
                />
              </Stack>
            </Box>

          </Box>
        }
        <Dialog
          open={reminderModal}
          onClose={() => setReminderModal(false)}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
        // className="dialog-assign"
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5
                className="p-3 mb-0"
                style={{ textAlign: "center", marginLeft: "100px" }}
              >
                {translations[language].sendReminder}
              </h5>
              <img
                src={taskAssign.closeIcon}
                alt=""
                style={{
                  height: "30px",
                  width: "30px",
                  cursor: "pointer",
                  marginLeft: "85px",
                }}
                onClick={() => setReminderModal(false)}
              />
            </div>
          </div>
          <DialogContent>
            <form noValidate autoComplete="off">
              <TextField
                fullWidth
                label={translations[language].enterReminderTitle}
                name="taskTitle"
                value={reminderData.taskTitle}
                onChange={(e) => handleChange(e)}
                className="mb-3"
              />
              <TextField
                fullWidth
                id="outlined-multiline-static"
                label={translations[language].description}
                name="taskDescription"
                multiline
                value={reminderData.taskDescription}
                onChange={handleChange}
                className="textarea-taskDescription mb-3"
                rows={3}
              />

              <button
                className="assign-task-button"
                onClick={handleSubmit}
              >
                {translations[language].sendReminder}
              </button>
            </form>
          </DialogContent>
        </Dialog>
        {galleryIsOpen &&
          <ImageGallery
            images={images}
            isOpen={galleryIsOpen}
            onClose={() => setGalleryIsOpen(false)}
            imageIndex={imageIndex}
          />

        }
      </Box>
    </>
  );
};
export default TaskDetail;
